import { spaceAPI } from '@/api';
import CommonSpaceDetailContainer, {
  FieldConfig,
} from '@/components/common/CommonSpaceDetailContainer';
import AvnfrGGHeader from './AvnfrGGHeader';
import { palette } from '@/modules/defines/styles';

interface DataType {
  id?: number;
  title: string;
  description: string;
  category: string;
  type: string;
  floor: number;
  link: string;
  phone: string;
  time: string;
  publish: boolean;
  updatedAt?: string;
}

const categoryMap: { [key: string]: string } = {
  '21': 'Dining',
  '22': 'Café&Dessert',
  '23': 'Fashion&Beauty',
  '24': 'Retail&Service',
};

const typeMap: { [key: string]: string } = {
  raon: '라온존',
  atti: '아띠존',
};

const fields: FieldConfig<DataType>[] = [
  {
    name: 'title',
    label: '이름',
    type: 'text',
    description: '공간의 이름을 입력해주세요',
    width: 'full',
  },
  {
    name: 'description',
    label: '설명',
    type: 'textarea',
    description: '공간에 대한 자세한 설명을 입력해주세요',
    width: 'full',
  },
  {
    name: 'category',
    label: '카테고리',
    type: 'select',
    options: Object.entries(categoryMap).map(([key, value]) => ({
      value: key,
      label: value,
    })),
    description: '공간의 카테고리를 선택해주세요',
    width: 'full',
  },
  {
    name: 'type',
    label: '타입',
    type: 'select',
    options: Object.entries(typeMap).map(([key, value]) => ({
      value: key,
      label: value,
    })),
    description: '공간의 타입을 선택해주세요',
    width: 'half',
  },
  {
    name: 'floor',
    label: '층수',
    type: 'number',
    placeholder: '층수를 입력하세요',
    description: '공간이 위치한 층수를 입력해주세요',
    width: 'half',
  },
  {
    name: 'phone',
    label: '전화번호',
    type: 'text',
    description: '전화번호를 입력해주세요',
    width: 'full',
  },
  {
    name: 'time',
    label: '영업시간',
    type: 'text',
    description: '공간의 영업시간을 입력해주세요',
    width: 'full',
  },
  {
    name: 'link',
    label: '링크',
    type: 'text',
    description: '공간과 관련된 웹페이지 링크를 입력해주세요',
    width: 'full',
  },
];

const AvnfrGGSpaceDetailContainer = () => {
  return (
    <CommonSpaceDetailContainer<DataType>
      HeaderComponent={AvnfrGGHeader}
      queryKey="getSpaceAvnfrGG"
      listQueryKey="getSpacesAvnfrgg"
      queryFn={(id) =>
      spaceAPI.getSpaceAvnfrGG({
        code: import.meta.env.VITE_SECRET_API_KEY,
          id,
        })
      }
      updateFn={(id, data) =>
      spaceAPI.updateSpaceAvnfrGG(
        {
          code: import.meta.env.VITE_SECRET_API_KEY,
        },
        {
            id,
          ...data,
        }
        )
      }
      fields={fields}
      switchFieldKey="publish"
      switchFieldLabel="앱에서 사용"
      defaultRoute="/avnfr-gg/space"
      themeColor={palette.mainAvnfr}
      themeHoverColor={palette.mainAvnfrHover}
    />
  );
};

export default AvnfrGGSpaceDetailContainer;
